<template>
  <section class="wrapper_type_2">
    <SuspendedModal :statusInfo="statusInfo" :branch="false"></SuspendedModal>
    <WarningModal :statusInfo="statusInfo" :branch="false"></WarningModal>
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand
        href="#"
        class="hamburger_container"
        :style="[
          statusInfo.status && statusInfo.status == 1
            ? { marginRight: '50px !important' }
            : null,
        ]"
      >
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>
      </b-navbar-brand>
      <div
        v-if="dealer"
        style="margin: 0 auto; margin-left: 100px; margin-right: 50px"
        class="m-hide"
      >
        <p class="text-center display-flex branchName" style="margin-bottom: 0">
          <span class="" style="font-size: 25px">{{
            dealer ? dealer.name : ""
          }}</span>
          <star-rating
            class="ml-2"
            v-model="dealerRating"
            :show-rating="true"
            :read-only="true"
            :star-size="starSize"
            :fixed-points="2"
            :round-start-rating="false"
          ></star-rating>
        </p>
      </div>

      <div style="margin: 0 auto; margin-right: 10%" class="m-hide"></div>

      <b-collapse id="nav-collapse" is-nav>
        <!-- <h4 class="mr-5">{{company ? company.name : ''}} </h4> -->

        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 1"
          class="payment_due_text"
        >
          <span class="text-black">
            {{ $t("text.cusMasterLayout.subscriptionExpire") }} </span
          ><span class="payment_due_date">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span
          >{{ $t("text.cusMasterLayout.pleasePay") }}
        </b-nav-item>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 2"
          class="payment_due_text"
        >
          {{ $t("text.cusMasterLayout.expired") }}
        </b-nav-item>

        <!--  <select @change="changeCountry" style="width: 280px !important">
            <option value="">select country</option>
            <option value="FR">France</option>
            <option value="NG">Nigeria</option>
            <option value="KE">Kenya</option>
          </select> -->

        <b-navbar-nav class="ml-auto">
          <div>
            <select
              @change="changeLanguage"
              v-model="usedLang"
              class="w-lg-100 mb-3 mb-md-3 mb-lg-0 mr-3"
            >
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select>
            <!-- <select
              @change="changeLanguage"
              class="w-lg-100 mb-3 mb-md-3 mb-lg-0 mr-3"
            >
              <option disabled value="">
                {{ $t("text.cMasterLayout.selectLanguage") }}
              </option>
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select> -->
          </div>

          <b-nav-item
            href="#"
            class="bell_noti"
            style="position: relative"
            v-if="statusInfo.status && statusInfo.status !== 0"
            @click="showNotification"
          >
            <img src="@/assets/img/notification.svg" width="28" />
          </b-nav-item>

          <b-nav-item href="#">
            <img
              :src="
                dealer && dealer.url
                  ? dealer.url
                  : require('@/assets/img/avatar.svg')
              "
              height="30px"
            />
          </b-nav-item>
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'dealerProfile' }">{{
                $t("text.cusMasterLayout.profile")
              }}</router-link></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cusMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="mt-3 text-right m-hide-icon">
        <img
          src="@/assets/img/close_btn.png"
          width="35px"
          height="35px"
          @click="toggleCollapsibleNavBar"
          id="mySidenav"
        />
      </div>
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>

        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="20" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <!-- If youre coming from company dashboard to dealer dashboard -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'companyDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.dealerId &&
              (userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'companyDashboard',
                query: { companyId: $route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.companyDashboard") }}
              </span>
            </router-link>
          </li>

          <!-- DEALER DASHBOARD -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'dealerDashboard' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'dealerDashboard',
                query: this.$route.query.dealerId
                  ? {
                      dealerId: this.$route.query.dealerId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/dashboard (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>

          <!-- UPDATE PRICE -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'dealer_price_management'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              (userInfo.roles.includes('CompanyPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Update Price')) ||
              (userInfo.roles.includes('Dealers') &&
                comPlanFeatures.includes('Update Price')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'dealer_price_management',
                query: this.$route.query.dealerId
                  ? {
                      dealerId: this.$route.query.dealerId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title"
                >{{ $t("text.cMasterLayout.updatePrice") }}
              </span>
            </router-link>
          </li>

          <!-- REPORTS -->
          <li
            v-if="
              (userInfo.roles.includes('CompanyReport') &&
                comPlanFeatures.includes('Report')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Report')) ||
              (userInfo.roles.includes('Dealers') &&
                comPlanFeatures.includes('Report')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'dealerSales' ||
              activeRoute === 'dealer_variance_report' ||
              activeRoute === 'BranchSalesTransactions' ||
              activeRoute === 'dealer_tanks_filled' ||
              activeRoute === 'dealer_branch_sales' ||
              activeRoute === 'dealer_tank_stock' ||
              activeRoute === 'dealer_cash_flow' ||
              activeRoute === 'DealerBranchesReport'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/profit-report (1).svg" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.reports") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'dealerSales',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealerSales' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.branchSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealer_variance_report',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_variance_report'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.pumpVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealerTankVariance',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_variance_report'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tankVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealer_tanks_filled',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_tanks_filled'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tanksFilled") }}
                  </router-link>
                </li>

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'dealer_cash_flow',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { dealerId: this.$route.query.dealerId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_cash_flow'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    Cash Flow
                  </router-link>
                </li> -->
                <li>
                  <router-link
                    :to="{
                      name: 'dealer_tank_stock',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_tank_stock'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tankStock") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealer_branch_sales',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_branch_sales'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.dealerSalesSummary") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealer_products_filled',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_products_filled'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.productsDischarged") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'dealer-product-valuation',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' dealer-product-valuation'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.stockValuation") }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    :to="{
                      name: 'DailyDealerBranchTrans',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' DailyDealerBranchTrans'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.dailyBranchTransactions") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'DealerBranchesReport',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' DealerBranchesReport'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.sendBranchReport") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- RETAIL OUTLET -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'dealerBranches' ? 'navbar_item_active' : ''
            "
            v-if="
              (userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              (userInfo.roles.includes('ViewOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              (userInfo.roles.includes('Dealers') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'dealerBranches',
                query: this.$route.query.dealerId
                  ? {
                      dealerId: this.$route.query.dealerId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/fuel-station (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.retailOutlet") }}
              </span>
            </router-link>
          </li>

          <!-- MANAGEMENT -->
          <li
            class="list-group-item treeview"
            v-if="
              (userInfo.roles.includes('ViewExpense') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('ManageExpense') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('ManageZones') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('ManagePayments') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('ViewBankLog') &&
                comPlanFeatures.includes('Management')) ||
              (userInfo.roles.includes('Dealers') &&
                comPlanFeatures.includes('Management')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            :class="
              activeRoute === 'manage_expenses' ||
              activeRoute === 'expenses_categories' ||
              activeRoute === 'zones' ||
              activeRoute === 'company_outstanding_payments' ||
              activeRoute === 'assets'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/briefcase.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.management") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userInfo.roles.includes('ViewExpense') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('Dealers') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'dealer_expenses',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_expenses'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.expenses") }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    v-if="
                      userInfo.roles.includes('ManageExpense') ||
                      userInfo.roles.includes('Company') ||
                      userInfo.roles.includes('Dealers') ||
                      userInfo.roles.includes('SupportAdmin') ||
                      userInfo.roles.includes('PartnerAdmin')
                    "
                    :to="{
                      name: 'dealer_expenses_categories',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'dealer_expenses_categories'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.expenseCategory") }}
                  </router-link>
                </li>

                <!-- <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'dealerShutdownHistory'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'dealerShutdownHistory',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">Shutdown pumps </span>
                  </router-link>
                </li> -->
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'DealerAggregatedFaults'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'DealerAggregatedFaults',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title"
                      >{{ $t("text.cusMasterLayout.dealerFault") }}
                    </span>
                  </router-link>
                </li>
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'DealerMaintenanceList'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'DealerMaintenanceList',
                      query: this.$route.query.dealerId
                        ? {
                            dealerId: this.$route.query.dealerId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">{{
                      $t("text.cusMasterLayout.maintenance")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- SUPPORT -->
          <li
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            class="list-group-item"
            :class="
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/svg/support.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">{{
                $t("text.cusMasterLayout.supportAdmin")
              }}</span>
            </router-link>
          </li>

          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="100px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="100px"
                  height="40px"
                />
              </div>
            </div>
          </div>
          <!-- major -->
          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <span class="mr-2"
              ><i
                class="mr-3 fa fa-sign-out"
                style="font-size: 20px; color: white"
              ></i
            ></span>
            <span class="sidenav_list_title">
              {{ $t("text.cusMasterLayout.logout") }}
            </span>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import configObject from "@/config";
import countryProducts from "@/products";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
import StarRating from "vue-star-rating";

export default {
  name: "MasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    StarRating,
  },
  data() {
    return {
      statusInfo: {},
      LogoUrl,
      isViewOnly: false,
      masterbackgroundUrl,
      dealer: {},
      companyIcon: null,
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      showStationManagementDropDown: false,
      showOurCorporateCustomersDropDown: false,
      showManageExpensesDropDown: false,
      showReportDropDown: false,
      showPeddlingManagementDropDown: false,
      supportedCompany: null,
      dealerRating: 0,
      starSize: 20,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    userName: {
      get() {
        if (localStorage.getItem("userDetails")) {
          return this.userDetails.firstName + "  " + this.userDetails.lastName;
        } else {
          return "Username";
        }
      },
      set(value) {},
    },
  },

  created() {
    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
      this.$eventHub.$emit("companyId", this.$route.query.companyId);
    }
    if (this.$route.query.dealerId && this.$route.query.companyId) {
      this.checkStatus();
      const useId = this.$route.query.companyId
        ? this.$route.query.companyId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Dealers/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyDealer = response.data.filter(
            (cur) => cur.id === this.$route.query.dealerId,
          );
          this.dealer = companyDealer[0];
          this.$eventHub.$emit("dealer", this.dealer);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.errors.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.errors.errorOcurred"),
              type: "error",
              duration: 5000,
            });
          }
        });
    }
    if (!this.$route.query.dealerId && !this.$route.query.companyId) {
      this.getDealer();
    }
    // if (
    //   !this.userInfo.roles.includes("SupportAdmin") ||
    //   this.userInfo.roles.includes("PartnerAdmin") ||
    //   this.userInfo.roles.includes("Company") ||
    //   this.userInfo.roles.includes("Dealers")
    // ) {
    //   this.getDealer();
    // }
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    if (
      this.userDetails.roles.includes("SupportAdmin") ||
      this.userDetails.roles.includes("PartnerAdmin")
    ) {
      this.support = true;
      this.dealerId = this.$route.query.dealerId;
      let ml = sessionStorage.getItem(this.dealerId);
      if (!ml) {
        let allData = localStorage.getItem("companiesList");
        let dt = JSON.parse(allData);
        dt.forEach((my, index) => {
          if (my.id === this.dealerId) {
            ml = JSON.stringify(my);
            sessionStorage.setItem(this.dealerId, ml);
          }
        });
      }
      // check this later

      this.dealer = JSON.parse(ml);
      this.$eventHub.$emit("dealer", this.dealer);
    }
    this.checkViewOnly();
    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  beforeMount() {
    // TO REROUTE TO OLD DASHBOARD FOR OLD CLIENT ROLES
    // if (
    //   this.$route.name == "dealerDashboard" &&
    //   this.userInfo.roles.includes("Old Client")
    // ) {
    //   this.$router.push({
    //     name: "dealerDashboard1",
    //     query: {
    //       companyId: this.$route.query.companyId,
    //       branchId: this.$route.query.branchId,
    //       groupId: this.$route.query.groupId,
    //       dealerId: this.$route.query.dealerId,
    //       regionId: this.$route.query.regionId,
    //     },
    //   });
    // }

    this.activeRoute = this.$route.name;
  },
  methods: {
    showNotification() {
      const status = this.statusInfo.status;
      if (
        (status == 1 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showWarningModal();
      if (
        (status == 2 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showSuspendedModal();
    },
    getDealerRating() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Dealer/${
            this.$route.query.dealerId
              ? this.$route.query.dealerId
              : this.dealer.id
          }`,
          configObject.authConfig(),
        )
        .then((res) => {
          if (typeof res.data.averageRateValue === "number") {
            this.companyRating = res.data.averageRateValue;
          }
        })
        .catch((e) => {});
    },
    checkStatus() {
      const modalShown = this.$store.getters.getModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getStatusInfo;
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (
              // this.$route.name !== "company_invoice" &&
              // this.$route.name !== "invoice_details" &&
              // this.$route.name !== "invoice_payments" &&
              !this.userInfo.roles.includes("SupportAdmin") ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showWarningModal();
              this.$store.commit("setModalShown", true);
            }
          }
          if (response.data.status == 2) {
            if (
              // this.$route.name !== "company_invoice" &&
              // this.$route.name !== "invoice_details" &&
              // this.$route.name !== "invoice_payments" &&
              !this.userInfo.roles.includes("SupportAdmin") ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    changeCountry(e) {
      console.log(e.target.value);
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      console.log(locale);
      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value]),
      );

      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      // console.log(e.target.value);
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      // console.log(locale);
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    checkViewOnly() {
      this.isViewOnly = this.$store.getters.getViewOnly;
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout"),
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    getDealer() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyDealers`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.dealer = response.data[0];

          // Logic for subscription plan feature
          let subPlanFeat;
          let isSubPlanFeat;
          subPlanFeat = response.data[0].planFeatures;
          isSubPlanFeat = localStorage.getItem("subPlanFeatures");
          if (!isSubPlanFeat) {
            localStorage.setItem(
              "subPlanFeatures",
              JSON.stringify(subPlanFeat),
            );
            this.comPlanFeatures = JSON.parse(
              localStorage.getItem("subPlanFeatures"),
            );
          }
          // this.comPlanFeatures = response.data[0].planFeatures;
          // console.log(this.comPlanFeatures);
          // Logic for subscription plan feature ended

          this.$eventHub.$emit("dealer", response.data[0]);

          // this.checkStatus();
          // this.getCompanyRating();
        })
        .catch((error) => {});
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title"),
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },
    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
};
</script>
